/* SAVE CRM DATA FROM METAFIELD */
function saveCRMPRofileData(customer_id, customer_email) {
  fetch(`${CUSTOM_APP_URL}/customers/save-crm-data`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      'customer[id]': customer_id,
      'customer[email]': customer_email,
    })
  });
}
/* SAVE CRM DATA FROM METAFIELD END */


/* SETUP ACCOUNT FORM */
function setupRegistrationForm() {
  populateCountySelect();
}

function setupNewsletterForm() {
  populateCountySelect();

  const mobileMarketing = document.getElementById('MobileMarketing');
  if (mobileMarketing) {
    mobileMarketing.addEventListener('input', function(){
      const fieldset = document.getElementById('MobileMarketingFieldset');
      if (fieldset) {
        if(this.checked){
          fieldset.classList.remove('hidden');
        } else {
          fieldset.classList.add('hidden');
        }
      }
    });
  }

  const newsletterEmailMarketing = document.getElementById('NewsletterEmailMarketing');
  if (newsletterEmailMarketing) {
    newsletterEmailMarketing.addEventListener('input', function(){
      const fieldset = document.getElementById('NewsletterEmailMarketingFieldset');
      if (fieldset) {
        if(this.checked){
          fieldset.classList.remove('hidden');
        } else {
          fieldset.classList.add('hidden');
        }
      }
    });
  }

  const postMarketing = document.getElementById('PostMarketing');
  if (postMarketing) {
    postMarketing.addEventListener('input', function(){
      const fieldset = document.getElementById('PostMarketingFieldset');
      if (fieldset) {
        if(this.checked){
          fieldset.classList.remove('hidden');
        } else {
          fieldset.classList.add('hidden');
        }
      }
    });
  }
}

function setupAccountForm(id, email){
  const accountForm = document.getElementById('account-form');
  if (accountForm) {
    accountForm.classList.add('is-loading');
  }
  populateCountySelect();
  populateAccountForm(id, email);
}

function populateCountySelect() {
  fetch(`${CUSTOM_APP_URL}/counties`)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    const countySelect = document.getElementById('County');
    if (countySelect && data.counties) {
      for(let i=0; i < data.counties.length; i++){
        const option = document.createElement('option');
        option.value = data.counties[i]['id'];
        option.textContent = data.counties[i]['name'];
        countySelect.appendChild(option);
      }
      const selectedValue = countySelect.dataset.selected;
      if(selectedValue){
        countySelect.value = selectedValue;
      }
    }
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}

function populateAccountForm(id, email) {
  const encodedEmail = encodeURIComponent(email);
  const url = new URL(`${CUSTOM_APP_URL}/customers/profile?customer[id]=${id}&customer[email]=${encodedEmail}`);

  fetch(url)
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    assignAccountFormValues(data.customer);
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}

function assignAccountFormValues(customer) {
  if(customer['gender']){
    const genderInput = document.querySelector(`[name="customer[gender]"][value="${customer['gender']}"]`);
    if (genderInput) {
      genderInput.checked = true;
    }
  }

  ['first_name', 'last_name', 'date_of_birth', 'phone', 'address1', 'zip', 'city', 'county_id'].forEach(key => {
    if(customer[key]){
      const input = document.querySelector(`[name="customer[${key}]"]`);
      if (input) {
        input.value = customer[key];
      }
    }
  });

  ['email_marketing', 'post_marketing', 'mobile_marketing'].forEach(key => {
    const input = document.querySelector(`[name="customer[${key}]"]`);
    if (input) {
      input.checked = customer[key] == 1;
    }
  });

  const countySelect = document.getElementById('County');
  if (countySelect) {
    countySelect.dataset.selected = customer['county_id'];
  }
  
  const accountForm = document.getElementById('account-form');
  if (accountForm) {
    accountForm.classList.remove('is-loading');
  }
}

/* SETUP ACCOUNT FORM END */

/* REGISTRATION AND ACCOUNT FORMS */
document.addEventListener('DOMContentLoaded', function() {
  const privacyConsent = document.getElementById('PrivacyConsent');
  const createCustomer = document.getElementById('CreateCustomer');
  
  if (privacyConsent && createCustomer) {
    privacyConsent.addEventListener('change', function(){
      createCustomer.disabled = !this.checked;
    });
  }

  const registrationForm = document.getElementById('registration-form');
  if (registrationForm) {
    registrationForm.addEventListener('submit', registerUser);
  }

  const accountForm = document.getElementById('account-form');
  if (accountForm) {
    accountForm.addEventListener('submit', updateUser);
  }

  // Phone mask functionality
  const phoneMask = document.getElementById('PhoneMask');
  const phoneHidden = document.getElementById('Phone');
  
  if (phoneMask && phoneHidden) {
    phoneMask.addEventListener('keyup', function(e){
      if (e.which < 48 || e.which > 57){
          e.preventDefault();
      }
      if(this.value){
        phoneHidden.value = this.value;
      } else {
        phoneHidden.value = "";
      }
    });
    
    phoneMask.addEventListener('input', function(e){
      if(this.value){
        phoneHidden.value = this.value;
      } else {
        phoneHidden.value = "";
      }
    });
  }

  // Show registration notice if needed
  if(urlParams.get('registered')){
    const noticeEl = document.getElementById('notice');
    if (noticeEl) {
      noticeEl.innerHTML = `
        <div class="note form-notice text--center">
          <p><strong>Važno!</strong><br>Molimo vas da odmah potvrdite aktivacijski link u vašem email sandučiću, kako bi vaša prijava bila zabilježena.</p>
        </div>
      `;
    }
  }
});

function registerUser(event){
  event.preventDefault();
  const form = event.target;
  const createButton = document.getElementById('CreateCustomer');
  
  if (createButton) {
    createButton.classList.add('btn--loading');
  }
  
  fetch(`${CUSTOM_APP_URL}/customers/register`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(assembleCustomerFormData(form))
  })
  .then(response => response.json())
  .then(data => {
    if(data.code == 200){
      window.location.replace("/account/login?registered=true");
    } else {
      renderErrors(data.errors.customer);
    }
  })
  .catch(error => {
    alert('Dogodila se pogreška, molimo pokušajte kasnije.');
    console.error('Error:', error);
  })
  .finally(() => {
    if (createButton) {
      createButton.classList.remove('btn--loading');
    }
  });
}

function updateUser(event){
  event.preventDefault();
  const form = event.target;
  const updateButton = document.getElementById('UpdateCustomer');
  
  if (updateButton) {
    updateButton.classList.add('btn--loading');
  }
  
  fetch(`${CUSTOM_APP_URL}/customers/update`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(assembleCustomerFormData(form))
  })
  .then(response => response.json())
  .then(data => {
    if(data.code == 200){
      window.location.replace("/account?updated=true");
    } else {
      renderErrors(data.errors.customer);
    }
  })
  .catch(error => {
    alert('Dogodila se pogreška, molimo pokušajte kasnije.');
    console.error('Error:', error);
  })
  .finally(() => {
    if (updateButton) {
      updateButton.classList.remove('btn--loading');
    }
  });
}

function assembleCustomerFormData(form){
  const data = {};
  
  // Helper function to get input value
  const getValue = (selector) => {
    const el = form.querySelector(selector);
    return el ? el.value : '';
  };
  
  // Helper function to get checked status
  const getChecked = (selector) => {
    const el = form.querySelector(selector);
    return el ? el.checked : false;
  };
  
  // Helper function to get checked radio value
  const getRadioValue = (name) => {
    const el = form.querySelector(`${name}:checked`);
    return el ? el.value : '';
  };

  data['customer[id]'] = getValue('[name="customer[id]"]');
  data['customer[email]'] = getValue('[name="customer[email]"]');
  data['customer[first_name]'] = getValue('[name="customer[first_name]"]');
  data['customer[last_name]'] = getValue('[name="customer[last_name]"]');
  data['customer[address1]'] = getValue('[name="customer[address1]"]');
  data['customer[zip]'] = getValue('[name="customer[zip]"]');
  data['customer[city]'] = getValue('[name="customer[city]"]');
  data['customer[county_id]'] = getValue('[name="customer[county_id]"]');
  data['customer[phone]'] = getValue('#Phone');
  data['customer[gender]'] = getRadioValue('[name="customer[gender]"]');
  data['customer[email_marketing]'] = getChecked('[name="customer[email_marketing]"]') ? 'on' : 'off';
  data['customer[mobile_marketing]'] = getChecked('[name="customer[mobile_marketing]"]') ? 'on' : 'off';
  data['customer[post_marketing]'] = getChecked('[name="customer[post_marketing]"]') ? 'on' : 'off';
  data['customer[date_of_birth]'] = getValue('[name="customer[date_of_birth]"]');
  data['customer[accepts_marketing]'] = getChecked('[name="customer[accepts_marketing]"]') ? 'true' : 'false';

  return data;
}

function renderErrors(errors){
  console.log(errors);
  
  // Remove existing errors
  document.querySelectorAll('.validation-error').forEach(el => el.remove());
  document.querySelectorAll('.error').forEach(el => el.classList.remove('error'));
  
  // Add new errors
  for (const [attribute, message] of Object.entries(errors)) {
    addErrorTo(attribute, message);
  }
  
  // Scroll to first error
  const firstError = document.querySelector('.error');
  if (firstError) {
    scrollToElement(firstError);
  }
}

function addErrorTo(field_name, messages){
  const field = document.querySelector(`[name="customer[${field_name}]"]:not([type="hidden"])`);
  if (field) {
    field.classList.add('error');
    const errorMsg = document.createElement('p');
    errorMsg.className = `validation-error field-${field_name}`;
    errorMsg.textContent = Array.isArray(messages) ? messages.join(', ') : messages;
    
    // Find the parent .field div and insert error message after it
    const fieldDiv = field.closest('.field');
    if (fieldDiv) {
      if (fieldDiv.nextSibling) {
        fieldDiv.parentNode.insertBefore(errorMsg, fieldDiv.nextSibling);
      } else {
        fieldDiv.parentNode.appendChild(errorMsg);
      }
    } else {
      // Fallback: insert after the input if no .field div found
      if (field.nextSibling) {
        field.parentNode.insertBefore(errorMsg, field.nextSibling);
      } else {
        field.parentNode.appendChild(errorMsg);
      }
    }
  }
}

function scrollToElement(element){
  const elementTop = element.offsetTop;
  const offset = window.innerHeight * 0.2;
  
  window.scrollTo({
    top: elementTop - offset,
    behavior: 'smooth'
  });
}


/* REGISTRATION AND ACCOUNT FORMS END */
